"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.highlight = void 0;
require("react-final-form-hooks");
require("../../../core");
const highlight = (fields, formApi) => {
    const state = formApi.form.getFieldState;
    fields.forEach((fieldName) => {
        var _a;
        (_a = state(fieldName)) === null || _a === void 0 ? void 0 : _a.blur();
    });
};
exports.highlight = highlight;
//# sourceMappingURL=highlight.js.map